@if (visible()) {
  <div
    class="loading-overlay"
    role="alert"
    aria-live="assertive"
    aria-busy="true"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
  >
    <div class="loading-overlay-box">
      <i
        class="fa-solid fa-spinner fa-spin-pulse loading-overlay-icon"
        aria-hidden="true"
      ></i>
      <span class="loading-overlay-text">{{ loadingMessage }}</span>
      <span
        class="visually-hidden"
        tabindex="0"
        >{{ loadingMessage }}</span
      >
    </div>
  </div>
}
